<!--
 Cote Website
 Created by Hu Fang.
 Copyright © GPHolding.ch. All rights reserved.
--> 

<template>
<div>
    <el-container class="homeCoteContainer">
    <el-header id="elHeader">
      <div id="header">
        <div id="header-safearea">
          <img class="logo-img" src="../../assets/img/cote/French_cote_logo_09.png" alt="cote-concierge"/>
          <el-button id="logo-button" @click="goCoteHomePage"></el-button>
          
          <el-menu
          id="el-menu-cote" 
          mode="horizontal"
          margin-left=80px
          margin-right=80px
          margin-top=50px
          height=20px
          background-color="#ffffff"
          text-color="#7f7f7f"
          active-text-color="#000000"
          menu-trigger="hover"
          overflow="hidden"
          text-overflow="ellipsis"
          style="border-bottom: none; ">

            <el-menu-item index="1" @click="goAboutUs" v-html='this.Localization.t("pc.aboutus.title")'></el-menu-item>
            
            <el-submenu index="2" @click="goFlagshipServices">
              <template slot="title"><span v-html='this.Localization.t("pc.common.services")'></span></template>
              <el-menu-item index="2-1" @click="goFlagshipServices" v-html='this.Localization.t("pc.flagshipservices.title")'></el-menu-item>
              <el-menu-item index="2-2" @click="goPrivateClient" v-html='this.Localization.t("pc.privateclient.title")'></el-menu-item>
              
            </el-submenu>

            <el-menu-item index="3" @click="goContact" v-html='this.Localization.t("pc.common.contact")'></el-menu-item>

            <el-menu-item index="4" >
              <div id="language-switch-container" class="hidden-sm-and-down">
                <el-button id="language-1" type="text" :class="this.Localization.locale =='en'? 'lang-button-active' : 'lang-button-inactive'" @click="switchLanguage('en')" style=" background-color: transparent; border-color: transparent;">EN</el-button>
                <span id="language-switch-slash">/</span>
                <el-button id="language-2" type="text" :class="this.Localization.locale =='en'? 'lang-button-inactive' : 'lang-button-active'" @click="switchLanguage('fr')" style=" background-color: transparent; border-color: transparent;">FR</el-button>
              </div>
            </el-menu-item>
          </el-menu>
        </div>
      </div>
    </el-header>
    <el-main class="elmain">
      <div class="main">
        <div id="coteVideo1" v-if="allowPlayback">
          <div class="video-box">
              <video-player  class="video-player vjs-custom-skin"
                      ref="videoPlayer"
                      :playsinline="true"
                      :options="playerOptions"
              ></video-player>
            </div>
        </div>

        <div id="coteVideo" v-else  @click="dialogVisible = true">
          <div class="conte-video-box">
            <div class="mask"></div>
            <img src="../../assets/img/cote/1.png" alt="">
          </div>
        </div>

        <div id="coteHome" style="position:relative; width: 100%;">
          <div id="coteHome-container">
            <img id="coteHome-img" src="../../assets/img/cote/pc/cote-pc-0218-01.png" alt="Cote Home"/>
            <p id="coteHome-description" >Unlock <span id="coteHome-desc-span">the secret</span> of luxury
            </p>
          </div>
        </div>

        <div id="about-us" style="position:relative; width: 100%;">
          <img id="about-us-image" src="../../assets/img/cote/pc/cote-pc-0218-02.png" alt="aboutUs"/>
          <div id="about-us-text-container" style="position:absolute;">
            <p id="about-us-title">
              <span id="about-us-title-span" v-html='this.Localization.t("pc.aboutus.title")'></span>
            </p>
            <div id="about-us-blur-bar"></div>
            <p id="about-us-description">
  <span id="about-us-span" v-html='this.Localization.t("pc.aboutus.title1")'></span><br>
  <span id="about-us-desc-span" v-html='this.Localization.t("pc.aboutus.desc1")'></span><br><br>

  <span id="about-us-span" v-html='this.Localization.t("pc.aboutus.title2")'></span><br>
  <span id="about-us-desc-span" v-html='this.Localization.t("pc.aboutus.desc2")'></span><br><br>

  <span id="about-us-span" v-html='this.Localization.t("pc.aboutus.title3")'></span><br>
  <span id="about-us-desc-span" v-html='this.Localization.t("pc.aboutus.desc3")'></span><br><br>
  </p>
          </div>
        </div>

        <div id="flagship-services" style="position:relative">
          <img id="flagship-services-image" src="../../assets/img/cote/pc/cote-pc-0218-03.png" alt="aboutUs"/>
          <div id="flagship-services-text-container" style="position:absolute;">
            <p id="flagship-services-title" v-html='this.Localization.t("pc.common.coteconcierge")'></p>
            <img id="flagship-services-title-image" :src="require('../../assets/img/cote/pc/cote-pc-0218-05-'+ this.Localization.locale + '.png')" alt="flagshipServiceTitle"/>
            
            <div id="flagship-services-blur-bar"></div>
            <p id="flagship-services-description">
              <span id="flagship-services-span" v-html='this.Localization.t("pc.flagshipservices.title1")'></span><br>
              <span id="flagship-services-desc-span" v-html='this.Localization.t("pc.flagshipservices.desc1")'></span><br><br>

              <span id="flagship-services-span" v-html='this.Localization.t("pc.flagshipservices.title2")'></span><br>
              <span id="flagship-services-desc-span" v-html='this.Localization.t("pc.flagshipservices.desc2")'></span><br><br>

              <span id="flagship-services-span" v-html='this.Localization.t("pc.flagshipservices.title3")'></span><br>
              <span id="flagship-services-desc-span" v-html='this.Localization.t("pc.flagshipservices.desc3")'></span><br><br>

              <span id="flagship-services-span" v-html='this.Localization.t("pc.flagshipservices.title4")'></span><br>
              <span id="flagship-services-desc-span" v-html='this.Localization.t("pc.flagshipservices.desc4")'></span>
            </p>
          </div>
        </div>

        <div id="private-client" style="position:relative">
          <img id="private-client-image" src="../../assets/img/cote/pc/cote-pc-0218-04.png" alt="aboutUs"/>
          <div id="private-client-text-container" style="position:absolute;">
            <p id="private-client-title" v-html='this.Localization.t("pc.privateclient.title")'></p>
            
            <p id="private-client-description">
              <span id="private-client-span" v-html='this.Localization.t("pc.privateclient.desc1")'></span><br>
              <span id="private-client-desc-span" v-html='this.Localization.t("pc.privateclient.desc2")'></span><br>
              <span id="private-client-span" v-html='this.Localization.t("pc.privateclient.desc3")'></span><br>
              <span id="private-client-desc-span" v-html='this.Localization.t("pc.privateclient.desc4")'></span><br>

              <span id="private-client-span" v-html='this.Localization.t("pc.privateclient.desc5")'></span><br>
              <span id="private-client-desc-span" v-html='this.Localization.t("pc.privateclient.desc6")'></span><br>

              <span id="private-client-span" v-html='this.Localization.t("pc.privateclient.desc7")'></span><br>
              <span id="private-client-span" v-html='this.Localization.t("pc.privateclient.desc9")'></span><br>
              <span id="private-client-desc-span" v-html='this.Localization.t("pc.privateclient.desc10")'></span><br>
              <span id="private-client-span" v-html='this.Localization.t("pc.privateclient.desc11")'></span>
              <span id="private-client-desc-span" v-html='this.Localization.t("pc.privateclient.desc12")'></span><br>
              <span id="private-client-span" v-html='this.Localization.t("pc.privateclient.desc13")'></span> 
              <span id="private-client-desc-span" v-html='this.Localization.t("pc.privateclient.desc14")'></span><br>
              <span id="private-client-span" v-html='this.Localization.t("pc.privateclient.desc15")'></span>
              <span id="private-client-desc-span" v-html='this.Localization.t("pc.privateclient.desc16")'></span><br>
            </p>
          </div> 
        </div>

        <div id="contact" style="position:relative">
          <div id='contact-safearea-container'> 
            <div id='contact-safearea'>

              <div id="contact-message-board-container">
                <p id="contact-message-board-title">{{this.Localization.t('pc.contactus.title')}}</p>
                <el-form id="contact-messageboardForm" :model="messageboardForm" :rules="rules" ref="messageboardForm" label-width="0">
                  <el-form-item id="contact-messageboardForm-item-line1" size="mini"> 
                    <el-col :span="11">
                      <el-form-item prop="firstname">
                        <el-input v-model="messageboardForm.firstname" :placeholder='this.Localization.t("pc.contactus.messageboard.firstname")'></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col class="line" :span="1">&nbsp</el-col>
                    <el-col :span="11">
                      <el-form-item prop="lastname">
                        <el-input v-model="messageboardForm.lastname" :placeholder='this.Localization.t("pc.contactus.messageboard.lastname")'></el-input>
                      </el-form-item>
                    </el-col>
                  </el-form-item>

                  <el-form-item id="contact-messageboardForm-item-line2" size="mini" >
                    <el-col :span="11">
                      <el-form-item prop="email" required>
                        <el-input v-model="messageboardForm.email" :placeholder='this.Localization.t("pc.contactus.messageboard.email")'></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col class="line" :span="1">&nbsp</el-col>

                    <el-col :span="11">
                      <el-form-item prop="phonenumber">
                        <el-input v-model="messageboardForm.phonenumber" :placeholder='this.Localization.t("pc.contactus.messageboard.phonenumber")'></el-input>
                      </el-form-item>
                    </el-col>
                  </el-form-item>

                  <el-form-item id="contact-messageboardForm-item-line3" size="mini"  prop="messagecontent">
                    <el-input id="messagecontent-input" type="textarea" v-model="messageboardForm.messagecontent" :placeholder='this.Localization.t("pc.contactus.messageboard.messagecontent")'></el-input>
                  </el-form-item>

                  <el-form-item id="contact-message-board-buttons">
                    <el-button id="contact-message-board-submit" @click="messageBoardSubmit" v-loading.fullscreen.lock="fullscreenLoading">{{this.Localization.t('pc.contactus.messageboard.send')}}</el-button>
                  </el-form-item>

                </el-form> 
              </div>

              <div id='contact-textContainer'>
                <p id="contact-us-title">{{this.Localization.t('pc.common.coteconcierge')}}</p>
                <p id="contact-us-description">{{this.Localization.t('pc.contactus.address')}} Rue Eugène Marziano, 37<br>CH - 1227 Genève - Suisse<br>
      <a href="tel:+41225000998" style="text-decoration: none; color: #ffffff">{{this.Localization.t('pc.contactus.phonenumber')}} +41 22 500 09 98</a><br>
      <a href="mailto:info@cote-concierge.ch" style="text-decoration: none; color: #ffffff">{{this.Localization.t('pc.contactus.email')}} info@cote-concierge.ch</a><br>
      <a style="text-decoration: none; color: #ffffff">{{this.Localization.t('pc.contactus.officehours')}}</a><br>
      <a href="https://www.cote-concierge.ch" style="text-decoration: none;"><span id="contact-us-desc-span">www.cote-concierge.ch</span></a><br>
      <a href="https://www.cote-magazine.ch" style="text-decoration: none;"><span id="contact-us-desc-span">www.cote-magazine.ch</span></a>
                </p>
                <img id="contact-us-img" src="../../assets/img/cote/cote_bottom_logo_04.png" alt="contactUs"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-main>

  </el-container>

  <el-dialog  :visible.sync="dialogVisible" width="600px" custom-class="dialog-class" append-to-body>
    <el-form ref="passwordForm" :model="videoForm" :rules="rules" label-width="100px" style="background-color: black !important;">
      <el-form-item  prop="videoPassword" required>
        <el-input v-model="videoForm.videoPassword" type="password" placeholder="Please enter the video password" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitPassword" v-loading.fullscreen.lock="fullscreenLoading">Confirm</el-button>
      <el-button @click="dialogVisible = false">Cancel</el-button>
    </div>
  </el-dialog>
</div>
</template>

<style lang="scss" scoped>
  .homeCoteContainer {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    position: relative;
    background-color: #ffffff; 
    border: none;

    /deep/ #elHeader {
      height: 140px !important;
      background-color: #ffffff; 
      padding: 0; 
      z-index: 100;
    }

    /deep/ #header {
      height: 140px;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: transparent;
    }

    /deep/ #header-safearea {
      position: absolute;
      width: 1200px;
      height: 116px; 
      background-color: transparent;
    }

    /deep/ .elmain {
      overflow-x: hidden;
      padding: 0;
    }

    /deep/ .main {
      line-height: 0px;  
    }

    /deep/ .logo-img {
      width: 142px !important; 
      height: 62px !important;  

      position: absolute;
      left: 0%;  
      top: 50%; 
      transform: translate(0,-50%);
      z-index: 130;
    }

    /deep/ #logo-button {
      position: absolute;
      width: 142px !important; 
      height: 62px !important;  

      left: 0%;  
      top: 50%; 
      transform: translate(0,-50%);
      
      background-color: transparent;
      border: none;
      z-index: 140;
    }
  }

  #el-menu-cote {
    font-family: AvertaStd-Regular; 
    font-size: 16px;
    position: absolute;
    right: 16.67%/*200px*/ !important;
    top: 50%; 
    transform: translate(0,-50%);
  }

  /*hide the down arrow*/
/*  .el-submenu__icon-arrow /deep/ .el-icon-arrow-down::before {
    visibility: hidden;
  }*/

  #language-switch-container {
    position: absolute;
    right: 0 !important;
    bottom: 0; 
    width: 60px; 
    height: 20px;
    font-family: AvertaStd-Regular;
    font-size: 16px;
    color: #7f7f7f !important;
    border: none;
    transform: translate(60%,-128%);
    z-index: 130;
  }

  #language-switch-slash {
    position: absolute;
    bottom: 50%;
    left: 50%;
    font-family: AvertaStd-Semibold;
    font-size: 16px;
    text-align: center;
    color: #000000;
    background-color: transparent;
    transform: translate(-50%,60%);
    z-index: 140;
  }

  .lang-button-inactive {
    font-family: AvertaStd-Regular;
    font-size: 16px;
    color: #7f7f7f !important;
  }

  .lang-button-active {
    font-family: AvertaStd-Semibold;
    font-size: 16px;
    color: #000000 !important;
  }

  #language-1 {
    position: absolute;
    background-color: transparent;
    width: 26px;/*15px;*/
    height: 35px;/*20px;*/
    bottom: 0;
    left: 0;
    text-align: left;
    transform: translate(0,25%);
    z-index: 150;
  }

  #language-2 {
    position: absolute;
    background-color: transparent;
    width: 26px;/*15px;*/
    height: 35px;/*20px;*/
    bottom: 0;
    right: 0;
    text-align: right;
    transform: translate(0,25%);
    z-index: 150;
  }

  #el-menu-cote /deep/ .el-menu-item {
    text-decoration: none;
  }

/*todo: adjust the text color of sub-menu*/
  .el-submenu /deep/ .el-menu-item {
    text-color: #7f7f7f !important;
    active-text-color: #000000 !important;
    background: transparent !important;
    border-bottom-color: transparent !important;
  }

  .el-submenu /deep/ .is-active {
    background: transparent !important;
    border-bottom-color: transparent !important;
  }

  .el-submenu /deep/ .el-submenu__title {
    active-text-color: #000000 !important;    
    border-bottom-color: transparent !important;
  }

  .el-menu-item:hover{
    outline: 0 !important;
    color: #000000 !important;
    background: transparent/*#013e6e*/ !important;
  }

  .el-menu-item.is-active {
    color: #000000/*#b89200*/ !important;
    background: transparent/*#013e6e*/ !important;
    border-bottom-color: transparent/*#013e6e*/ !important;

    font-family: AvertaStd-Semibold; /*Gotham-Bold; */
    font-size: 16px;
  }

  .el-menu-item {
    /*text-decoration: none;*/
  }

  .el-submenu__icon-arrow /deep/ .el-icon-arrow-down {
    visibility: false;
  }

  .el-submenu {
    background: transparent !important;
    border-bottom-color: transparent !important;
  }

/*menu navigation*/
  #el-menu-cote /deep/ .el-submenu__title:hover { 
    color: #000000 !important;
    font-family: AvertaStd-Semibold;
    background: transparent !important;
    /*font-size: 16px;*/
  }

  #el-menu-cote /deep/ .el-submenu.is-active { 
    color: #000000 !important;
    font-family: AvertaStd-Semibold;  
    font-size: 16px;
  }

  #el-menu-cote /deep/ .el-menu-item:hover { 
    color: #000000 !important;
    font-family: AvertaStd-Semibold;  
    /*font-size: 16px;*/
  }

  #el-menu-cote /deep/ .el-submenu .el-menu-item:hover { 
    color: #000000 !important;
    font-family: AvertaStd-Semibold;  
    /*font-size: 16px;*/
  }

  .main {
    width: 100%;
    height: 100%;
  }

/*todo: adjust the layout of language-switch-container*/

/*Cote Home page*/

  #coteHome {
    height: 900px; 
    background: #000222;
  }

  #coteHome-container {
    position: absolute; 
    width: 450PX;
    height: 360PX;
    left: 50%;
    top: 50%;  
    transform: translate(-50%, -50%);
    background: transparent;
    z-index: 0;
  }

  #coteHome-img {
    width: 382PX ; 
    height: 241PX ; 
    position: absolute;  
    left: 50%;
    top: 0;  
    transform: translate(-50%, 0);
    z-index: 10;
  }

  #coteHome-description {
    position: absolute;  
    left: 0;
    right: 0;
    top: 291PX;
    color: #ffffff; 
    font-family: BodoniStd;
    font-size: 36PX; 
    text-align: center;
    z-index: 10;
  }

  #coteHome-desc-span {
    /*font-family: Avenir-Next-Regular; */
    font-family: AvertaStd-Extrathin;
  }

/*About Us page*/
  #about-us {
    width: 100%;
    min-height: 800px;/*900px; */
    max-height: 100%;
    background-color: white;
    z-index: 0;
    overflow: hidden; 
  }

  #about-us-image {
    position: absolute;
    left: 0 !important;
    /*min-height: 900px;*/
    height: auto;
    width: 61.8%;/*66.67%;*/
    z-index: 1;
  }

  #about-us-text-container {
    right: 0;
    width: 600px;
    /*min-height: 900px;*/
    height: 100%;
    width: 38.2%;/*33.33%;*/
    position: absolute;
    overflow: hidden;
    background: white;
    /*padding-bottom: 20%;      */
    overflow: hidden;
    z-index: 5;
  }

  #about-us-title {
    position: absolute;
    top: 150px;
    left: 0px;/*66px;*/
    right: 0px;/*66px;*/
    /*width: 100%;*/
    color: #000000;
    font-family: Zapfino;
    font-size: 48px;
    text-align: center; 
    z-index: 10;
  }

  #about-us-blur-bar {
    position: absolute;
    left: 66px; 
    right: 66px;
    top: /*208px*/228px !important; 
    height: 2PX !important;
    background-color: #000000;
    z-index: 10;
  }

  #about-us-description {
    position: absolute;  
    top: /*250px;*/290px;
    left: 66px;/*100px;*/
    right: 66px;/*100px;*/
    bottom: 160px;
    color: #000000; 
    font-family: Avenir-Next-Medium;
    font-size: 14px; 
    text-align: center;
    line-height: 21px;
    z-index: 10;
  }

  #about-us-span {
    font-family: Didot-Bold;
    font-size: 18px; 
    color: #AC050A;
    /*line-height: 21px;*/
  }

/*business client(flagship services)*/

  #flagship-services {
    width: 100%;
    min-height: 800px;/*900px; */
    max-height: 100%;
    background-color: white;
    z-index: 0;
    overflow: hidden; 
  }

  #flagship-services-image {
    position: absolute;
    right: 0;
    /*min-height: 900px;*/
    height: auto;
    width: 61.8%;/*66.67%;*/
    z-index: 1;
  }

  #flagship-services-text-container {
    left: 0;
    width: 38.2%;/*33.33%;*/
    /*min-height: 900px;*/
    height: 100%;
    position: absolute;
    /*overflow: hidden;*/
    background: white;
    z-index: 5;
  }

  @media only screen and (max-width: 1299px) {
    #flagship-services-title {
      position: absolute;
      top: 60px;/*90px; */
      left: 0;
      right: 0;
      /*width: 100%;*/
      color: #000000;
      font-family: Zapfino;
      font-size: 48px;
      text-align: center; 
      z-index: 10;
    }

    #flagship-services-title-image {
      position: absolute;  
      top: 130px;/*160px; */
      right: 50%;
      width: 240px; /*todo: 144px*/
      height: 78px; /*todo: 46.8px*/
      transform: translate(50%,0);
      z-index: 10;     
    }   

    #flagship-services-blur-bar {
      position: absolute;
      top: 226px;/*256px; */
      left: 66px;/*100px; */
      right: 66px;/*100px;*/
      height: 2PX !important;
      background-color: #000000;
      z-index: 10;
    }
    
    #flagship-services-description {
      position: absolute;  
      top: 280px;
      left: 66px;
      right: 66px;
      bottom: 50px;
      color: #000000; 
      font-family: Avenir-Next-Medium;
      font-size: 14px; 
      text-align: center;
      line-height: 21px;
      z-index: 10;
    }
  }

  @media only screen and (min-width: 1300px) {
    #flagship-services-title {
      position: absolute;
      top: 80px !important;
      left: 0;
      right: 0;
      /*width: 100%;*/
      color: #000000;
      font-family: Zapfino;
      font-size: 48px;
      text-align: center; 
      z-index: 10;
    }

    #flagship-services-title-image {
      position: absolute;  
      top: 135px !important; 
      right: 50%;
      width: 240px; 
      height: 78px;     
      transform: translate(50%,0);
      z-index: 10;        
    } 

    #flagship-services-blur-bar {
      position: absolute;
      top: 236px !important; 
      left: 66px;/*100px; */
      right: 66px;/*100px;*/
      height: 2PX !important;
      background-color: #000000;
      z-index: 10;
    }

    #flagship-services-description {
      position: absolute;  
      top: 260px; /*280px; */
      left: 66px;
      right: 66px;
      bottom: 50px;
      color: #000000; 
      font-family: Avenir-Next-Medium;
      font-size: 14px; 
      text-align: center;
      line-height: 21px;
      z-index: 10;
    }
  }

  #flagship-services-span {
    font-family: Didot-Bold;
    font-size: 18px; 
    color: #AC050A;
  }

/*Private Client*/
  #private-client {
    width: 100%;
    min-height: 800px;/*900px; */
    max-height: 100%;
    background-color: white;
    z-index: 0;
    overflow: hidden; 
  }

  #private-client-image {
    position: absolute;
    left: 0;
    /*min-height: 900px;*/
    width: 61.8%;/*66.67%;*/
    height: auto;
    z-index: 1;
  }

  #private-client-text-container {
    right: 0;
    width: 38.2%;/*33.33%;*/
    /*min-height: 900px;*/
    height: 100%;
    position: absolute;
    /*overflow: hidden;*/
    background: white;
    /*overflow: hidden;*/
    z-index: 5;
  }

  @media only screen and (max-width: 1299px) {
    #private-client-title {
      position: relative;
      top: 120px;/*160px;*/ 
      left: 50%;
      /*right: 0;*/
      width: 400px !important;
      color: #000000;
      font-family: Zapfino;
      font-size: 48px;
      text-align: center; 
      transform: translate(-50%,0);
      padding-bottom: 30px; /* replace blur bar, as it has offset on some browser*/
      border-bottom: 2PX solid #000000;
      z-index: 10;
    }
    #private-client-description {
      position: absolute;  
      top: 240px;/*280px;*/
      left: 66px;
      right: 66px;
      bottom: 50px;
      color: #000000; 
      font-family: Avenir-Next-Medium;
      font-size: 14px; 
      text-align: center;
      line-height: 30px;
      z-index: 10;
    }
  }

  @media only screen and (min-width: 1300px) {
    #private-client-title {
      position: relative;
      top: 142px;/*132px;*//*175px;*/ /*192px*/
      left: 50%;
/*      right: 0;*/
      width: 400px !important;
      color: #000000;
      font-family: Zapfino;
      font-size: 48px;
      text-align: center; 
      transform: translate(-50%,0);
      padding-bottom: 20px;/*30px;*/ /* replace blur bar, as it has offset on some browser*/
      border-bottom: 2PX solid #000000;
      z-index: 10;
    }

    #private-client-description {
      position: absolute;  
      top: 237px;/*280px;*/
      left: 66px;
      right: 66px;
      bottom: 50px;
      color: #000000; 
      font-family: Avenir-Next-Medium;
      font-size: 14px; 
      text-align: center;
      line-height: 30px;
      z-index: 10;
    }
  }

/*  #private-client-blur-bar {
    position: absolute;
    top: 242px !important; 
    left: 66px;//100px; 
    right: 66px;//100px;
    height: 2PX !important;
    background-color: #000000;
    z-index: 10;
  }*/



  #private-client-span {
    font-family: Avenir-Next-Bold;
  }

/*Contact page*/
  #contact {
    width: 100%;
    min-height: 960px;/*900px;*/
    max-height: 100%;
    background-color: #000222;
    z-index: 0;
    overflow: hidden; 
    display: flex;
    justify-content: center;
  }

  #contact-safearea-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: transparent;
  
    display: flex;
    justify-content: center;  
    z-index: 10;
  }

  #contact-safearea {
    position: absolute;
    width: 1200px;  
    height: 100%; 
    background-color: transparent; 
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 30;
  }

  #contact-textContainer {
    top: 460px;/*600px;*//*483.3px; todo: shrink above area*/
    position: absolute;
    width: 1200px; 
    height: 928px;/*868px;*//*808px;*/ 
    max-height: 100%;
    background-color: transparent;
    overflow: hidden; 
    z-index: 40;
  }

  #contact-us-title {
    position: absolute;  
    left: 0;
    top: 66px;/*90px;*//*48px;*/
    width: 100%;
    color: #ffffff;
    font-family: Zapfino; 
    font-size: 28px;
    text-align: center;
    z-index: 50;
  }

  #contact-us-description {
    position: absolute;  
    top: 120px;/*116px;*/ 
    left: 50%;     
    max-width: 100%;
    color: #ffffff; 
    font-family: Avenir-Next-Regular;  
    font-size: 16px; 
    line-height: 24px;
    text-align: center;  
    /*display: inline-block;
    white-space: nowrap;*/
    transform: translate(-50%,0);
    z-index: 50;
  }

/*  #contact-us-desc-span {
    color: #AC050A;
    font-family: Avenir-Next-Bold; 
  }*/
  #contact-us-desc-span {
    color: #AC050A;
    font-family: Avenir-Next-Regular;  
    font-weight: 1000;
  }

  #contact-us-img {
    position: absolute;  
    width: 101PX;
    height: 60PX;

    left: 50%;
    top: 350px;/*320px; 342px;*/
    /*bottom: 80px; */
    transform: translate(-50%,0);
    z-index: 50;    
  }

/*form*/
  #contact-message-board-container {
    position: absolute;
    width: 760px;  
    top: 0;/*400px;*/
    bottom: 20px;
    max-height: 100%;
    background-color: transparent;
    overflow: hidden; 

    display: flex;
    justify-content: center;
    z-index: 40;
  }

  #contact-message-board-title {
    position: absolute;
    width: 100%; 
    top: 80px;/*14px; */ 
    /*margin-top: 0;
    margin-bottom: 0;*/
    color: #ffffff;
    font-family: Zapfino; 
    font-size: 28px;
    text-align: center; 
    z-index: 50;
  }

  #contact-messageboardForm {
    top: 146px !important; /*80px*/ 
    margin-top: 146px/*80px*/;  
    width: 760px;/*760px;*/
    color: white;
    font-family: AvertaStd-Regular;
    font-size: 12px; 
    z-index: 50;
  }

  .el-input {
    /*height: 56px !important; *//*56px*/
    font-family: AvertaStd-Regular;
    font-size: 12px;/*16px;*/ 
    color: white !important;
    border-style: none;
  }

  .el-input /deep/ .el-input__inner {
    height: 30px/*28px*/ !important;/*56px !important;*/
    width: 370px !important;
    border-radius: 2px;
    color: white !important;
    background-color: rgba(255,255,255,0.5);
    /*padding-top: 0;
    padding-bottom: -5px;*/

    &::placeholder {
        font-family: AvertaStd-Regular;
        font-size: 12px;/*16px; */
        color: white;
    }

    &::-webkit-input-placeholder {
        color: white;
    }

    &:-moz-placeholder {
        color: white;
    }

    &::-moz-placeholder {
        color: white;
    }

    &:-ms-input-placeholder {
        color: white;
    }
  }

  .el-form-item /deep/ .el-input__inner, .el-form-item /deep/ .el-input__inner:focus, .el-form-item /deep/ .el-textarea__inner, .el-form-item /deep/ .el-textarea__inner:focus {
      border-color: transparent;
  }

  .el-form-item /deep/ .is-error .el-input__inner, .el-form-item /deep/ .is-error .el-input__inner:focus, .el-form-item /deep/ .is-error .el-textarea__inner, .el-form-item /deep/ .is-error .el-textarea__inner:focus {
      border-color: transparent;
  }

  .el-textarea {
    font-family: AvertaStd-Regular;
    font-size: 12px;/*16px; */
    color: white !important;
    border-style: none;
  }

  .el-textarea /deep/ .el-textarea__inner {
    /*messagecontent input 文字的font*/
    font-family: AvertaStd-Regular;
    font-size: 12px;/*16px; */
    height: 147px !important;
    width: 750px !important;
    border-radius: 2px;

    color: white !important;
    background-color: rgba(255,255,255,0.5);

    &::placeholder {
        color: white;
    }

    &::-webkit-input-placeholder {
        color: white;
    }

    &:-moz-placeholder {
        color: white;
    }

    &::-moz-placeholder {
        color: white;
    }

    &:-ms-input-placeholder {
        color: white;
    }
  }

  #contact-message-board-submit {
    width: 240px !important;
    height: 34px !important;/*32px 56px !important;*/
    /*padding-bottom: 0 0 0 0;*/
    font-family: AvertaStd-Regular;
    font-size: 14px;/*16px; */
    border-style: none;
    border-radius: 2px;
    background-color: rgba(255,255,255,0.2);
    color: white;
  }

  #contact-message-board-submit:hover {
    background-color: rgba(255,255,255,0.5);
  }

  #coteVideo,
  #coteVideo1 {
    height: 900px;
    width: 100%;
    //background-image: url(https://www.leclanche.com/wp-content/uploads/2021/09/Pic-of-both-Ontario-ferries_2-scaled.jpg);
    background-image: url(../../assets/img/cote/3.jpg);
    background-size: 100% 900px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #coteVideo1:before,
  #coteVideo:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(44, 63, 72, 0.85);
  }
  .conte-video-box {
    position: relative;
    width: 1153px;
    height: 650px;
  }

  .conte-video-box img {
    width: 100%;
    height: 100%;
  }

  .mask {
      position: absolute;
      display: none;
      top: 0;
      left: 0;
      // width: 900px;
      // height: 507px;
      width: 1153px;
      height: 650px;
      background: rgba(0, 0, 0, .4) url(../../assets/img/cote/5.png) no-repeat center;
      background-size: 50px 50px;
  }

  .conte-video-box:hover .mask {
      display: block;
      cursor: pointer;
  }

  .video-box {
    width: 1153px;
    margin: 0 auto;
  }

  .dialog-class {
    background-color: black !important;
  }

  /deep/ .el-dialog__header {
    background: #25363d;
    height: 0 !important;
  }

  /deep/ .el-dialog__body {
    background: #25363d;
  }

  /deep/ .el-dialog__footer {
    background: #25363d;
  }

</style>

<script>
  import router from '../../router';
  export default {
    data() {
      var fullscreenLoading= false;
      var regOfEmail = RegExp(/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/);
      // var regOfSQLValid = RegExp(/select|update|delete|exec|count|'|"|=|;|>|<|%/i);
      var validateEmail = (rule, value, callback) => {
        if(value === '') {
          callback(new Error(this.Localization.t('pc.contactus.messageboard.email_errmsg')));
        } else if (!value.match(regOfEmail)) {
          callback(new Error(this.Localization.t('pc.contactus.messageboard.email_errmsg2')));
        } else if (value.length > 30) {
          callback(new Error(this.Localization.t('pc.contactus.messageboard.length_errmsg', {count : 30 })));
        } 
        else {
          callback();
        }
      };
      var validateFirstname = (rule, value, callback) => {
        if(value === '') {
          callback(new Error(this.Localization.t('pc.contactus.messageboard.firstname_errmsg')));
        } else if (value.length > 30) {
          callback(new Error(this.Localization.t('pc.contactus.messageboard.length_errmsg', {count : 30 })));
        } else {
          callback();
        }
      };
      var validateLastname = (rule, value, callback) => {
        if(value === '') {
          callback(new Error(this.Localization.t('pc.contactus.messageboard.lastname_errmsg')));
        } else if (value.length > 30) {
          callback(new Error(this.Localization.t('pc.contactus.messageboard.length_errmsg', {count : 30 })));
        } else {
          callback();
        }
      };
      var validatePhonenumber = (rule, value, callback) => {
        if (value.length > 30) {
          callback(new Error(this.Localization.t('pc.contactus.messageboard.length_errmsg', {count : 30 })));
        } else {
          callback();
        }
      };
      var validateMessagecontent = (rule, value, callback) => {
        if(value === '') {
          callback(new Error(this.Localization.t('pc.contactus.messageboard.messagecontent_errmsg')));
        } else if (value.length > 1000) {
          callback(new Error(this.Localization.t('pc.contactus.messageboard.messagecontent_errmsg2', {count : 1000 })));
        } else {
          callback();
        };
      };
      return {
        fullscreenLoading: false,

        messageboardForm: {
          firstname: "",
          lastname: "",
          email: "",
          phonenumber: "",
          messagecontent: ""
        },
        rules: {
          firstname: [
            { validator: validateFirstname, trigger: 'blur'},
          ],            
          lastname: [
            { validator: validateLastname, trigger: 'blur'},
          ],
          email: [
            { validator: validateEmail, trigger: 'blur'},
          ],
          phonenumber: [
            { validator: validatePhonenumber, trigger: 'blur'},

          ],
          messagecontent: [
            { validator: validateMessagecontent, trigger: 'blur'},
          ],
          videoPassword: [
            { validator: validateMessagecontent, trigger: 'blur'},
          ]
        },
        playerOptions : {
            playbackRates : [ 0.5, 1.0, 1.5, 2.0 ], //可选择的播放速度
            autoplay : false, //如果true,浏览器准备好时开始回放。
            muted : false, // 默认情况下将会消除任何音频。
            loop : false, // 视频一结束就重新开始。
            preload : 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
            language : 'zh-CN',
            aspectRatio : '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
            fluid : true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
            sources : [ {
                type : "",
                src : 'http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4'//url地址
            } ],
            poster : "", //你的封面地址
            // width: document.documentElement.clientWidth,
            notSupportedMessage : '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
            controlBar : {
                timeDivider : true,//当前时间和持续时间的分隔符
                durationDisplay : true,//显示持续时间
                remainingTimeDisplay : false,//是否显示剩余时间功能
                fullscreenToggle : true  //全屏按钮
            }
        },
        videoForm: {
          videoPassword: null
        },
        allowPlayback: false,
        dialogVisible: false,
      }
    },
    methods: {
      //提交密码
      submitPassword() {
        this.$refs["passwordForm"].validate((valid) => {
          if (!valid) {
            alert(this.Localization.t('pc.contactus.messageboard.send_errmsg'));
            throw new Error('Submisson check: data is not valid.');
          }
        });

        var url = this.GLOBAL.BASE_URL + this.GLOBAL.MESSAGEBOARD_CHECKPASSWORD;
        var data = {
          password: this.videoForm.videoPassword,
        };
        this.fullscreenLoading = true;

        fetch(url, {
          method: 'POST',
          body: JSON.stringify(data),
          headers: new Headers({
            'Content-Type': 'application/json'
          })
        }).then(res => res.json())
        .catch(error => {
            console.error('Error:', error);
            alert(this.Localization.t('pc.contactus.messageboard.send_errmsg2'));
        })
        .then((response) => {
          console.log(response);
            this.fullscreenLoading = false;
            if(response.code == '0') {
              this.playerOptions.sources[0].src = response.obj;
              this.allowPlayback = true;
              this.dialogVisible = false;
              this.$refs.videoPlayer.player;
            } else {
              if(response.msg != null) {
                alert(this.Localization.t('pc.contactus.messageboard.send_errmsgwithdetails', {details : response.msg}));
              } else {
                alert(this.Localization.t('pc.contactus.messageboard.send_errmsg'));
              }
            };
            setTimeout(() => {
              this.fullscreenLoading = false;
            }, 5000);
        })
      },
      goCoteHomePage() {
        window.location.href = "#coteHome";
      },
      goAboutUs() {
        window.location.href = "#about-us";
      },
      goFlagshipServices() {
        window.location.href = "#flagship-services";
      },
      goPrivateClient() {
        window.location.href = "#private-client";   
      },
      goContact() {
        window.location.href = "#contact";
      },
      switchLanguage: function(language){
        console.log('switched to '+ language);
        switch(language) {
          case 'fr':
            this.Localization.locale = language;
            break;
          case 'en':
            this.Localization.locale = language;
            break;
          default:
            // this.Localization.locale = 'fr'; /*default language*/
            break;
        };
      },
      messageBoardSubmit() {
        this.$refs["messageboardForm"].validate((valid) => {
          //validate data before sending network request.
          if (!valid) {
            // console.log('Submisson check: data is not valid.');
            // process.exit();
            alert(this.Localization.t('pc.contactus.messageboard.send_errmsg'));
            throw new Error('Submisson check: data is not valid.');
          }
        });

        /*messagecontent: this.messageboardForm.messagecontent*/






        var url = this.GLOBAL.BASE_URL + this.GLOBAL.MESSAGEBOARD_ENDPOINT;
        var data = {firstname: this.messageboardForm.firstname,
          lastname: this.messageboardForm.lastname,
          email: this.messageboardForm.email,
          phonenumber: this.messageboardForm.phonenumber,
          messagecontent: this.messageboardForm.messagecontent
        };
        this.fullscreenLoading = true;

        fetch(url, {
          method: 'POST',
          body: JSON.stringify(data),
          headers: new Headers({
            'Content-Type': 'application/json'
          })
        }).then(res => res.json())
        .catch(error => {
            console.error('Error:', error);
            alert(this.Localization.t('pc.contactus.messageboard.send_errmsg2'));
        })
        .then((response) => {
            this.fullscreenLoading = false;
            if(response.code == '0') {
              alert(this.Localization.t('pc.contactus.messageboard.send_sucessmsg'));
            } else {
              if(response.msg != null) {
                alert(this.Localization.t('pc.contactus.messageboard.send_errmsgwithdetails', {details : response.msg}));
              } else {
                alert(this.Localization.t('pc.contactus.messageboard.send_errmsg'));
              }
            };
            setTimeout(() => {
              this.fullscreenLoading = false;
            }, 5000);
        })
      },


// /防止SQL注入
// function AntiSqlValid(oField )
// {
// re= /select|update|delete|exec|count|'|"|=|;|>|<|%/i;
// if ( re.test(oField.value) )
// {
// //alert("请您不要在参数中输入特殊字符和SQL关键字！"); //注意中文乱码
// oField.value = ";
// oField.className="errInfo";
// oField.focus();
// return false;
// }
    }
  }
</script>    
